import axios_org from "axios";

const axios = axios_org.create({
  baseURL: "/api/",
});
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};
export default axios;
